import React from "react"

const TabviewControllersContainer = ({ className, children }) => {
  return (
    <div
      className={`mr-0 flex justify-content-end pb-2 gap-3 ${className ?? ""}`}
    >
      {children}
    </div>
  )
}

export default TabviewControllersContainer
